import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next'
import moment from "moment";
import { getToken } from "../../utils/auth";

const ShareToFeedPopup = ({ show, handleClose, data }) => {
  const [description, setDescription] = useState("");
    const { t, i18n } = useTranslation();    
  const handleShare = async () => {
    try {
        const token = getToken();

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/share-event`,
        {
          eventId: data?._id,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message || "Post shared successfully!");
      handleClose();
    } catch (error) {
      console.error("Error sharing post:", error);
      toast.error(error?.response?.data?.message || "Failed to share the post.");
    }
  };



  return (<>
  <Toaster position="top-right" reverseOrder={false}/>
    <Modal show={show} onHide={handleClose} centered >
      <Modal.Header closeButton>
        <Modal.Title>{t('shareToFeed')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{maxHeight:"60vh", overflowY:"auto"}}>
        <Form.Group className="mb-3">
          <Form.Label>{t('enter_description')}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Group>
{/* Group Body */}


<div>
<div className="user-post-data">
                          <div className="d-flex justify-content-between">
                            <div className="me-3">
                              <img
                                className="rounded-circle img-fluid"
                                src="/calender.webp"
                                style={{ width: "55px" }}
                                alt=""
                              />
                              <div
                                style={{
                                  justifyContent: "center",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  marginTop: "-75%",
                                  display: "flex",
                                  color: "rgb(58,51,61)",
                                }}
                              >
                                {moment(
                                  data?.startDate ? data?.startDate : "1"
                                ).format("D")}
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h5 className="mb-0 d-inline-block">
                                    {data?.title}
                                  </h5>
                                  <p
                                    className="mb-0 text-primary"
                                    style={{ color: "black" }}
                                  >
                                    {data?.location}
                                  </p>
                                </div>
                                <div
                                  className="card-post-toolbar"
                                  style={{ display: "flex" }}
                                >
                                  {data?.qrCodeUrl ? (
                                    <div>
                                      <img
                                        src={data?.qrCodeUrl}
                                        // onClick={() =>
                                        //   handleQrClick(data?.qrCodeUrl)
                                        // }
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "20px",
                          }}
                        >
                          <div className="containergrid">
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('start_date')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.startDate).format(
                                  "MMM D, YYYY"
                                )}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('startTime')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.startDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('end_date')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.endDate).format("MMM D, YYYY")}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('endTime')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.endDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              color: "red",
                            }}
                          >
                            {data?.note ? (
                              <div>{t('note')}: {data?.note}</div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                          {/* {expandedPosts[index] && ( */}
                            <>
                              <div className="mt-3">
                              <p dangerouslySetInnerHTML={{ __html: data?.description }} />
                              </div>
                              {data?.image && (
                              <div className="user-post">
                                <img
                                  src={data?.image}
                                  alt="post1"
                                  className="img-fluid rounded w-100"
                                />
                              </div>)}
                            </>
                        </div>
                        </div>


{/* Group Body End */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button variant="primary" onClick={handleShare}>
          {t('share')}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default ShareToFeedPopup;
